export const LIST_ID_DECLARATION = '##declaration';
export const LIST_ID_DOCUMENTS = '##documents';

export const isApplicativeListId = (id: string | undefined): id is string => !!id && id.startsWith('##');
